<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 200 200"
    style="enable-background: new 0 0 200 200"
    xml:space="preserve"
  >
    <rect style="fill: #ffffff" width="200" height="200" />
    <g>
      <path
        style="fill: #34495e"
        d="M77.5,74.1c4.6,0,9.2,0,14.2,0c2.9,5,5.4,10,8.3,15c2.9-5,5.8-10,8.3-15c4.6,0,9.2,0,14.2,0
		L100,112.9c-1.2-2.5-2.9-4.6-4.2-7.1C90,95.4,83.8,85,77.9,75"
      />
      <g>
        <path
          style="fill: #4ebb8a"
          d="M95.4,130.8c1.7,2.5,2.9,5,4.6,7.9L132.9,82c1.7-2.5,4.6-7.9,4.6-7.9h-0.8c0,0-9.6,0-14.2,0
			L100,112.9c-1.2-2.5-2.9-4.6-4.2-7.1C90,95.4,77.9,75,77.9,75l-0.4-0.8h-15"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: "IconVue",
};
</script>
